
import React from 'react';
import {DashboardContainer, Spinner} from "../../funcs/utils";
import { connect } from "react-redux";
import { sprintf } from "sprintf-js";
import ReactTable from "react-table";
import { centsToString } from "../../../lib/currency-utils";

const BillingDetails_ = props => {

  const username = props.username;
  const key = sprintf("%04d", props.acct_index);
  const advisor_fee = props.app.wlf.advisory_fee;
  const sub_advisor_fee = props.app.wlf.sub_advisory_fee;
  let data;

  if (username) {
    data = props.data[username] && props.data[username][key];
  } else {
    data = props.data[props.wlf_id];
  }

  const spinner = !data ? (
    <div align={"center"}>
      <Spinner size={"2rem"}/>
    </div>
  ) : null;

  const tables = [];

  const year_style = {
    fontSize: "1.5rem",
    fontWeight: "bold",
  }

  const AdvisorFeeCell = row => {
    if (username) {
      return (
        <span>{row.original.advisor.fee_bps}</span>
      )
    }
    return (
      <span>{advisor_fee}</span>
    )
  }

  const SubAdvisorFeeCell = row => {
    if (username) {
      return (
        <span>{row.original.sub_advisor.fee_bps}</span>
      )
    }
    return (
      <span>{sub_advisor_fee}</span>
    )
  }

  if (data) {
    data.items.forEach((item, index) => {
      const year_container_style = {
        marginTop: index === 0 ? "1rem" : "4rem",
      }
      tables.push((
        <div key={index}>
          <div style={year_container_style}>
            <span style={year_style}>{item.year}</span>
          </div>
          <div>
            <ReactTable
              data={item.items}
              pageSize={item.items.length}
              className = "-striped -highlight"
              showPagination = {false}
              columns={[
                {
                  Header: "Date",
                  id: "date",
                  accessor: item => sprintf(
                    "%02d/%02d/%04d", item.month, item.day, item.year),
                },
                {
                  Header: "Total AUM",
                  id: "aum",
                  accessor: item => centsToString(item.aum_cents),
                },
                {
                  Header: "Advisor Fee",
                  id: "adv_fee",
                  Cell: AdvisorFeeCell,
                },
                {
                  Header: "Sub Advisor Fee",
                  id: "sub_adv_fee",
                  Cell: SubAdvisorFeeCell,
                },
                {
                  Header: "Current",
                  id: "current",
                  accessor: item => centsToString(
                    item.advisor.current - item.sub_advisor.current),
                },
                {
                  Header: "Paid YTD",
                  id: "ytd",
                  accessor: item => centsToString(
                    item.advisor.ytd - item.sub_advisor.ytd),
                },
                {
                  Header: "Paid Total",
                  id: "total",
                  accessor: item => centsToString(
                    item.advisor.total - item.sub_advisor.total),
                },
              ]}
            />

          </div>
        </div>
      ))
    })
  }

  return (
    <DashboardContainer
      client={props.client}
      title={"Billing History"}>
      { spinner }
      { tables }
    </DashboardContainer>
  )
}

const mapStateToProps = state => {
  return {
    client: state.client,
    app: state.app,
  }
}

const BillingDetails = connect(mapStateToProps)(BillingDetails_);

export { BillingDetails };
